import { useNavigate } from 'react-router-dom';
import ErrorMessage from '@/components/ErrorMessage';
import Loading from '@/components/general/Loading';
import GoBackLink from '@/components/GoBackButton';
import SeminarAbout from '@/components/SeminarAbout';
import SeminarVideo from '@/components/SeminarVideo';
import { SeminarContentType } from '@/services/seminars';
import * as Styles from './SeminarDetails.styles';

type SeminarDetailsType = SeminarContentType & {
  isLoading: boolean;
  notFound: boolean;
};

const SeminarDetailsComponent = function ({
  isLoading,
  notFound,
  ...props
}: SeminarDetailsType): JSX.Element {
  const navigate = useNavigate();

  const goBack = (): void => navigate(-1);

  if (isLoading) {
    return <Loading fullPage />;
  }

  if (notFound) {
    return (
      <div>
        <GoBackLink onClick={goBack} />
        <ErrorMessage
          aboveTitle="Oh no!"
          description="Please, go back and select another seminar."
          title="Seminar not found."
        />
      </div>
    );
  }

  return (
    <div>
      <Styles.Container data-testid="seminar-details">
        <GoBackLink onClick={goBack} />
        <SeminarVideo {...props} />
        <SeminarAbout {...props} />
      </Styles.Container>
    </div>
  );
};

export default SeminarDetailsComponent;
